import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from '@material-ui/core';

const ConfirmDelete = ({
  onConfirm,
  onReject,
  open,
  content,
  docName,
}: {
  onConfirm: any;
  onReject: any;
  open: boolean;
  content: string;
  docName: string;
}) => {
  return (
    <Dialog open={open}>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button
          role="button"
          variant="contained"
          title="delete-confirm-btn"
          color="primary"
          onClick={() => onConfirm(docName)}
        >
          Delete
        </Button>
        <Button
          role="button"
          variant="contained"
          color="secondary"
          onClick={onReject}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmDelete;
